import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine, Linear } from 'gsap'
import { trace } from 'rytm-helpers';
import { initSmBg } from './sm/smbg';


const onLoadingComplete = () => {
  // start bg animation after delay
  setTimeout(initSmBg, 2000)
  // remove index-loading class name
  setTimeout(() => {
    document.documentElement.classList.remove("index-loading")
  }, 600)
}

const initIntro = (el) => {  
  const bgs = [...el.querySelectorAll(".loading-bg > div")]
  const title = el.querySelector(".title")
  const words = title ? [...title.querySelectorAll("span")] : []
  const header = document.querySelector(".header-full")
  const brand = header ? header.querySelector(".brand") : null
  const footer = document.querySelector(".header-full")
  const main = document.querySelector("main.main")
  const t = new TimelineMax({repeat: 0})
  const wW = window.innerWidth
  const wH = window.innerHeight

  TweenMax.set(title, {opacity: 1})
  TweenMax.set(header, {opacity: 0})
  TweenMax.set(brand, {y: -200})
  TweenMax.set(footer, {opacity: 0})
  TweenMax.set(main, {opacity: 0})
  words.forEach((el, index) => {
    const x = index % 2 ? wW : -wW
    const y = index % 2 ? wH : -wH
    TweenMax.set(el, {x, y: 0})
    t.to(el, .5, {x: 0, ease: Expo.easeOut, delay: .4}, 0)
    t.to(el, .5, {y, ease: Expo.easeIn}, 2.4)
  })
  bgs.forEach((bg, index) => {
    const y = index % 2 ? wH : -wH
    t.to(bg, .5, {y, ease: Expo.easeIn}, 2.5)
  })
  t.to(header, .4, {opacity: 1, ease: Power3.easeOut}, 3.2)
  t.to(brand, 1, {y: 0, ease: Expo.easeOut}, 3.3)
  t.to(footer, .4, {opacity: 1, ease: Power3.easeOut, onComplete: onLoadingComplete}, 3.2)
  t.to(main, .8, {opacity: 1, ease: Power3.easeOut}, 3.4)
}

export const loadingSequence = () => {
  const box = document.getElementById("box-loading")
  if (box) {
    initIntro(box)
  } else {
    onLoadingComplete()
  }
  
}